import MaintenanceWorkflowForwardingCheckinEntrySection from "../../../Sections/CheckinEntry";
import MaintenanceWorkflowForwardingDirectiveEntrySectionExecutionEntry from "../../../Sections/DirectiveEntry/Entries/ExecutionEntry";
import MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection from "../../../Sections/EstablishmentChoiceEntry";
import MaintenanceWorkflowForwardingFinancialReviewEntrySection from "../../../Sections/FinancialReviewEntry";

const ExecutionEntryOnGoingCheckin = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingDirectiveEntrySectionExecutionEntry />

      <MaintenanceWorkflowForwardingCheckinEntrySection
        showTransportAutoEntriesDeliveryCodeWithComplete
      />

      <MaintenanceWorkflowForwardingFinancialReviewEntrySection />

      <MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection
        manualEntryProps={{
          showProposalDiagnostic: true,
        }}
      />
    </>
  );
}

export default ExecutionEntryOnGoingCheckin;
